exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\nstrong{\r\n    font-weight: inherit;\r\n}\r\n\r\n[_nghost-c1]\r\n{\r\n    border:0px !important;\r\n}\r\n\r\n/* .mat-paginator-navigation-previous\r\n{\r\n    position: absolute;\r\n    left: 2em;\r\n}\r\n*/\r\nbs-modal-backdrop.modal-backdrop.fade.in.show {\r\n    opacity: 0.7;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/neenu.korula/AA/eventorg-web/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!C:/Users/neenu.korula/AA/eventorg-web/node_modules/postcss-loader/lib?{"ident":"postcss"}!C:/Users/neenu.korula/AA/eventorg-web/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles